
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"id":"Group_45761","data-name":"Group 45761","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 20 20"}, attrs),
              ...rest,
            },
            children.concat([_c('defs',[_c('clipPath',{attrs:{"id":"clip-path93823"}},[_c('rect',{attrs:{"id":"Rectangle_14253","data-name":"Rectangle 14253","width":"20","height":"20","fill":"#1c84fa"}})])]),_c('g',{attrs:{"id":"Group_42900","data-name":"Group 42900"}},[_c('g',{attrs:{"id":"Group_42800","data-name":"Group 42800"}},[_c('g',{attrs:{"id":"Mask_Group_22128","data-name":"Mask Group 22128","clip-path":"url(#clip-path93823)"}},[_c('path',{attrs:{"id":"Path_27681","data-name":"Path 27681","d":"M314.279 237.213a1.279 1.279 0 00-1.186-.832h-2.973v-4.173a1.282 1.282 0 00-1.275-1.284 1.283 1.283 0 00-1.163.747l-3.83 8.371a1.277 1.277 0 00.628 1.694 1.3 1.3 0 00.535.117h2.962v4.17a1.28 1.28 0 001.27 1.288h.009a1.281 1.281 0 001.163-.747l3.83-8.373a1.266 1.266 0 00.035-.978zm-5 8.814v-4.449a1.038 1.038 0 00-1.038-1.037l-3.206.048 3.768-8.382v4.449a1.041 1.041 0 001.037 1.038h3.185z","transform":"translate(-299.045 -229.175)","fill":"#262626"}})])])])])
          )
        }
      }
    